<template>
  <div class="contents">
    <div class="contents-inner">
      <div class="main" :class="{ isFixed: fixedId !== '' }">
        <div class="contents-top">
          <div class="list-top-wrapper">
            <div class="list">
              <div class="list-head">
                <div class="sort-wrapper">
                  <MiniButton
                    class="sort-button"
                    @clickButton="toggleSortMenu()"
                  >
                    <svg
                      class="sort-icon"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 10.31 13"
                      width="10.31px"
                      height="13px"
                    >
                      <g>
                        <path
                          d="M10.19,10.35a.41.41,0,0,0-.59,0h0L8.36,11.58V.42a.42.42,0,1,0-.84,0V11.58L6.29,10.34a.42.42,0,0,0-.59.59l1.94,2a.44.44,0,0,0,.6,0l1.95-2A.41.41,0,0,0,10.19,10.35Z"
                        />
                        <path
                          d="M2.66.12a.42.42,0,0,0-.59,0h0l-1.95,2a.41.41,0,0,0,0,.59.43.43,0,0,0,.58,0L2,1.43V12.59a.41.41,0,0,0,.41.41.41.41,0,0,0,.42-.41V1.43L4,2.67a.42.42,0,0,0,.59,0,.41.41,0,0,0,0-.59h0Z"
                        />
                      </g>
                    </svg>
                    <span class="minibutton-text">並び替え</span>
                  </MiniButton>
                  <Transition name="fade-fast" mode="out-in">
                    <Sort
                      class="sort-panel"
                      :defaultSortType="sortType"
                      @clickSort="handleClickSort"
                      v-show="menuIsShown"
                    />
                  </Transition>
                </div>
                <div class="head-content">
                  <p class="head-text">アイテム情報</p>
                </div>
              </div>
              <div class="list-fixed" v-if="fixedItem">
                <ItemTop :data="fixedItem" :isActive="true" />
              </div>
              <div class="list-items">
                <div class="list-slider">
                  <swiper
                    class="itemList"
                    ref="topSwiper"
                    :options="topSwiperOptions"
                  >
                    <swiper-slide
                      class="itemList-item"
                      v-for="item in sortedItems"
                      :key="item.jan_code"
                      ><ItemTop :data="item"
                    /></swiper-slide>
                  </swiper>
                </div>
              </div>
            </div>
          </div>
          <CircleButton class="arrow-button -left btn-prev">
            <img
              class="arrow-icon"
              src="../../../assets/images/_parts/other/arrow_left.svg"
              alt="戻る"
            />
          </CircleButton>
          <CircleButton class="arrow-button -right btn-next">
            <img
              class="arrow-icon"
              src="../../../assets/images/_parts/other/arrow_right.svg"
              alt="進む"
            />
          </CircleButton>
        </div>
        <div class="contents-bottom">
          <div class="list">
            <div class="list-line">
              <ul class="list-line-inner" ref="menuLines">
                <li><span class="list-line-text">アイテム説明</span></li>
                <li><span class="list-line-text">レビュー</span></li>
                <li><span class="list-line-text">価格</span></li>
                <li><span class="list-line-text">内容量</span></li>
                <li><span class="list-line-text">ブランド</span></li>
                <li><span class="list-line-text">受賞</span></li>
                <li><span class="list-line-text">肌悩み</span></li>
                <li><span class="list-line-text">特長</span></li>
                <li><span class="list-line-text">使用期間</span></li>
                <li><span class="list-line-text">使用感</span></li>
                <li><span class="list-line-text">香り</span></li>
                <li><span class="list-line-text">医薬部外品</span></li>
                <li><span class="list-line-text">主な有効成分</span></li>
                <li><span class="list-line-text">アルコールフリー</span></li>
                <li><span class="list-line-text">パラベンフリー</span></li>
                <li><span class="list-line-text">オイルフリー</span></li>
                <li><span class="list-line-text">販売名称</span></li>
                <li>
                  <span class="list-line-text">
                    ラインナップ <br /><span class="list-note"
                      >※一部商品のみ</span
                    ></span
                  >
                </li>
                <li><span class="list-line-text">レフィル</span></li>
                <li class="fixed-height">
                  <span class="list-line-text">
                    使用方法 <br /><span class="list-note"
                      >※美容液のみ</span
                    ></span
                  >
                </li>
              </ul>
            </div>
            <div class="list-head"></div>
            <div class="list-fixed" v-if="fixedItem">
              <ItemBottom
                ref="fixedBottomItem"
                :data="fixedItem"
                :isActive="true"
                :isSerumCategory="isSerumCategory"
                :isSpView="isSpView"
              />
            </div>
            <div class="list-items">
              <div class="list-slider">
                <swiper
                  class="itemList"
                  ref="bottomSwiper"
                  :options="bottomSwiperOptions"
                >
                  <swiper-slide
                    class="itemList-item"
                    v-for="item in sortedItems"
                    :key="item.jan_code"
                    ><ItemBottom
                      ref="bottomItems"
                      :data="item"
                      :isSerumCategory="isSerumCategory"
                      :isSpView="isSpView"
                  /></swiper-slide>
                </swiper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ItemTop from "./ItemTop.vue";
import Sort from "./Sort.vue";
import ItemBottom from "./ItemBottom.vue";
import MiniButton from "../../ui/buttons/MiniButton.vue";
import CircleButton from "../../ui/buttons/CircleButton.vue";
import { adobeClickEvent } from "../../../modules/analytics";
import { SORT_TYPE } from "../../../config/SORT_TYPE";

export default {
  name: "contents",
  components: {
    ItemTop,
    Sort,
    ItemBottom,
    MiniButton,
    CircleButton,
  },

  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      topSwiperOptions: {
        slidesPerView: "auto", // ページ内に何枚スライドを表示するか
        simulateTouch: false, // タッチと同じ動作をマウスでも受け付けるか
        watchOverflow: true, // 端に行った時、ナビゲーションボタンが非表示にするか
        freeMode: true, // フリーモードにするかしないか
        // passiveListeners: false,
        navigation: {
          nextEl: ".btn-next",
          prevEl: ".btn-prev",
          disabledClass: "is-hidden",
        },
      },
      bottomSwiperOptions: {
        slidesPerView: "auto",
        simulateTouch: false,
        watchOverflow: true,
        freeMode: true,
        // passiveListeners: false,
      },
      fromItemPage: false,
      timeoutId: null,
      screenWidth: 0,
      sortType: SORT_TYPE.priceAscending,
      menuIsShown: false,
    };
  },
  computed: {
    ...mapGetters("product", ["selectedProductIds", "fixedId", "review"]),
    ...mapGetters("selectedFormIds", ["selectedCategory"]),
    ...mapGetters("jsonData", ["tables", "forms"]),
    isSp() {
      return this.screenWidth < 600;
    },
    topSwiper() {
      return this.$refs.topSwiper.$swiper;
    },
    bottomSwiper() {
      return this.$refs.bottomSwiper.$swiper;
    },
    selectedItem() {
      return this.items.filter((item) =>
        this.selectedProductIds.includes(item.jan_code)
      );
    },
    normalListItems() {
      if (this.fixedItem)
        return this.selectedItem.filter(
          (item) => item.jan_code !== this.fixedItem.jan_code
        );
      else return this.selectedItem;
    },
    fixedItem() {
      if (!this.fixedId) return undefined;
      else return this.items.find((item) => item.jan_code === this.fixedId);
    },
    sortedItems() {
      switch (this.sortType) {
        case SORT_TYPE.priceAscending:
          return this.priceSort(this.normalListItems, "ascending");
        case SORT_TYPE.priceDescending:
          return this.priceSort(this.normalListItems, "descending");
        case SORT_TYPE.reviewAscending:
          return this.reviewSort(this.normalListItems, "ascending");
        case SORT_TYPE.reviewDescending:
          return this.reviewSort(this.normalListItems, "descending");
        case SORT_TYPE.reviewNumDescending:
          return this.reviewNumSort(this.normalListItems, "descending");
        case SORT_TYPE.reviewNumAscending:
          return this.reviewNumSort(this.normalListItems, "ascending");

        default:
          return this.priceSort(this.normalListItems, "ascending");
      }
    },
    isSerumCategory() {
      const selectedValues =
        this.forms.bigan_names[this.selectedCategory].values;
      const selectedCategoryTextArray = selectedValues.map(
        (keyValue) => this.tables.bigan_names[keyValue]
      );
      const serumIsSelected = selectedCategoryTextArray.includes("美容液");
      return serumIsSelected;
    },
    isSpView() {
      return this.screenWidth <= 600;
    },
  },
  created() {
    this.screenWidth = window.innerWidth;
    window.addEventListener("resize", this.handleResize.bind(this));
    window.addEventListener("click", this.handleWindowClick.bind(this));
  },
  mounted() {
    this.$nextTick(() => {
      this.topSwiper.controller.control = this.bottomSwiper;
      this.bottomSwiper.controller.control = this.topSwiper;
      this.adjustHeight();
    });
  },
  updated() {
    this.$nextTick(() => {
      this.adjustHeight();
    });
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize.bind(this));
    window.removeEventListener("click", this.handleWindowClick.bind(this));
  },
  methods: {
    analyze(eventId, url) {
      adobeClickEvent(eventId, url);
    },
    handleResize() {
      this.debounce(() => {
        const currentWidth = window.innerWidth;
        if (this.screenWidth === currentWidth) return;
        this.screenWidth = currentWidth;
        this.adjustHeight();
      });
    },
    debounce(callback) {
      if (this.timeoutId) clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => {
        callback();
        this.timeoutId = null;
      }, 200);
    },
    adjustHeight() {
      /**
       * カードの配列
       */
      const bottomItems = !this.$refs.fixedBottomItem
        ? [...this.$refs.bottomItems]
        : [...this.$refs.bottomItems, this.$refs.fixedBottomItem];

      /**
       * 各カードの中身の要素配列が集まった配列
       */
      const cardChildren = bottomItems.map((item) =>
        Array.from(item.$refs.card.children)
      );

      /**
       *  存在するカードの数。
       */
      const itemLength = cardChildren.length;

      /**
       *  １つのカード内に存在する枠の数。
       */
      const tableNumInOneItem = cardChildren[0].length - 1; //最後の「使用方法」は枠の高さが固定のため-1して対象から外す

      const maxHeightsArray = Array(tableNumInOneItem).fill(0);
      const menuLinesArray = Array.from(this.$refs.menuLines.children);

      //少しでも負荷を減らすためにfor文を使用
      // const startTime = performance.now();
      {
        // jsで設定したスタイルのリセット
        for (let i = 0; i < itemLength; i++) {
          const item = cardChildren[i];
          for (let j = 0; j < tableNumInOneItem; j++) {
            item[j].style.height = "";
            menuLinesArray[j].style.height = "";
          }
        }
      }

      {
        // それぞれの枠の最大高さを算出してmaxHeightsArrayに格納
        for (let i = 0; i < itemLength; i++) {
          const item = cardChildren[i];
          for (let j = 0; j < tableNumInOneItem; j++) {
            const maxHeight = maxHeightsArray[j];
            const currentInnerHeight = item[j].children[0].clientHeight;
            const currentMenuHeight = menuLinesArray[j].clientHeight;
            maxHeightsArray[j] = Math.max(
              maxHeight,
              currentInnerHeight,
              currentMenuHeight
            );
          }
        }
      }

      {
        // 最大高さをそれぞれの枠に適用してスタイリング
        for (let i = 0; i < itemLength; i++) {
          const item = cardChildren[i];
          for (let j = 0; j < tableNumInOneItem; j++) {
            const maxHeight = `${maxHeightsArray[j]}px`;
            item[j].style.height = maxHeight;
            menuLinesArray[j].style.height = maxHeight;
          }
        }
      }

      // const endTime = performance.now();
      // console.log({ time: endTime - startTime });
    },
    handleClickSort(sortType) {
      this.menuIsShown = false;
      if (this.sortType === sortType) return;
      this.sortType = sortType;
    },
    handleWindowClick(evt) {
      const target = evt.target;
      const isMenuClicked = target.closest(".menu") !== null;
      const isButtonClicked = target.closest(".sort-button") !== null;
      const isBlankSpaceClicked = !isMenuClicked && !isButtonClicked;
      const needsHidingMenu = isBlankSpaceClicked && this.menuIsShown;
      if (needsHidingMenu) this.menuIsShown = false;
    },

    /**
     * @param {'ascending', 'descending'} type
     */
    priceSort(targetArray, type) {
      return targetArray.sort((a, b) => {
        const priceA = a.komi_kkk;
        const priceB = b.komi_kkk;

        if (type === "ascending") {
          return priceA <= priceB ? -1 : 1;
        } else {
          return priceA >= priceB ? -1 : 1;
        }
      });
    },

    /**
     * @param {'ascending', 'descending'} type
     */
    reviewSort(targetArray, type) {
      return targetArray.sort((a, b) => {
        const reviews = this.review;
        const poolCodeA = a.pool_code;
        const poolCodeB = b.pool_code;
        const reviewA = reviews.find((review) => review.poolId === poolCodeA);
        const reviewB = reviews.find((review) => review.poolId === poolCodeB);
        if (!reviewA) return 1;
        if (!reviewB) return -1;

        const valueA = reviewA.totalEvaluation;
        const valueB = reviewB.totalEvaluation;
        if (type === "ascending") {
          return valueA <= valueB ? -1 : 1;
        } else {
          return valueA >= valueB ? -1 : 1;
        }
      });
    },

    /**
     * @param {'ascending', 'descending'} type
     */
    reviewNumSort(targetArray, type) {
      return targetArray.sort((a, b) => {
        const reviews = this.review;
        const poolCodeA = a.pool_code;
        const poolCodeB = b.pool_code;
        const reviewA = reviews.find((review) => review.poolId === poolCodeA);
        const reviewB = reviews.find((review) => review.poolId === poolCodeB);
        if (!reviewA) return 1;
        if (!reviewB) return -1;

        const valueA = parseInt(reviewA.totalCount, 10);
        const valueB = parseInt(reviewB.totalCount, 10);
        if (type === "ascending") {
          return valueA <= valueB ? -1 : 1;
        } else {
          return valueA >= valueB ? -1 : 1;
        }
      });
    },

    toggleSortMenu() {
      this.analyze("sort");
      this.menuIsShown = !this.menuIsShown;
    },
  },
};
</script>
<style lang="scss" scoped>
.contents {
  $contentsWidth: 960px;
  $sidePadding: 20px;
  width: 100%;
  max-width: $contentsWidth + $sidePadding * 2;
  padding: 0 $sidePadding;
  margin: 0 auto;
  .contens-inner {
    width: 100%;
  }

  .main {
    width: 100%;
    position: relative;
  }

  .contents-top {
    background-color: #fff;

    position: sticky;
    top: 0;
    z-index: 2;
    margin-top: 25px;
    padding-top: 10px;
    /* overflow: hidden; */
  }

  .list-top-wrapper {
    overflow: hidden;

    & > .list {
      border-bottom: 1px solid #ddd;
    }
  }
  .list {
    width: 100%;
    display: flex;
    position: relative;
  }

  .list-head {
    width: 95px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
  }

  .sort-button {
  }

  .sort-icon {
    width: 10px;
    height: 13px;
    margin-right: 3px;
  }

  .head-content {
    margin-top: auto;
    height: 100%;
  }

  .head-text {
    margin-top: 40px;
    font-size: 12px;
    font-weight: 600;
    text-align: left;
  }

  .list-fixed {
    width: 220px;
    margin: 0 15px;
    flex-shrink: 0;
  }

  .list-items {
    flex-shrink: 1;
    flex-grow: 1;
    overflow: hidden;
  }

  .list-slider {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .itemList {
    display: flex;
    padding: 0 15px;
    height: 100%;
  }

  .itemList-item {
    margin-right: 30px;
    width: 220px;

    &:last-child {
      margin-right: 0;
    }
  }

  .list-line {
    position: absolute;
    z-index: 0;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .list-line-inner {
    li {
      width: 100%;
      border-bottom: 1px solid #ddd;
      text-align: left;
      padding: 10px 0 10px 0;
      font-size: 12px;
      font-weight: 600;
      text-align: left;

      &:last-child {
        border-bottom: none;
      }

      &.fixed-height {
        height: 200px !important;
      }

      & > .list-note {
        font-size: 0.85em;
        font-feature-settings: "palt";
        padding-left: 1em;
        text-indent: -1em;
        display: inline-block;
        line-height: 1.2;
      }
    }
  }

  .arrow-button {
    $size: 40px;
    width: $size;
    position: absolute;
    z-index: 1;
    top: 178px;
    outline: none;
    &.-left {
      left: 88px;
    }
    &.-right {
      right: -$size/2;
    }

    &.is-hidden {
      display: none;
    }
  }

  .isFixed {
    .arrow-button {
      &.-left {
        left: 338px;
      }
    }
  }

  .arrow-icon {
    width: 20px;
    height: 7px;
  }

  .sort-wrapper {
    position: relative;
    width: 100%;
  }
  .sort-panel {
    width: 203px;
    position: absolute;
    top: 52px;
    left: 0;
    z-index: 2;
  }

  @include media() {
    $sidePadding: 20px;
    width: 100%;
    max-width: none;
    padding: 0 0 0 $sidePadding;

    .contents-top {
      position: sticky;
      top: 0;
      z-index: 2;
      padding-top: vw(14);
    }

    .list-head {
      width: 3.5em;
    }
    .list-line-text {
      display: block;
      width: 4em;
    }
    .minibutton-text {
      display: none;
    }

    .sort-button {
      width: auto;
    }

    .sort-icon {
      width: vw(8);
      height: vw(10);
      margin-right: vw(3);
    }

    .head-content {
      margin-top: auto;
      height: 100%;
    }
    .head-text {
      margin-top: vw(35);
      font-size: vw(10);
    }

    $gap: vw(10);
    .list-fixed {
      width: vw(120);
      margin: 0;
      margin-left: $gap;
    }

    .list-items {
      margin-left: $gap/2;
    }

    .list-slider {
    }

    .itemList {
      display: flex;
      padding: 0;
    }

    .itemList-item {
      margin: 0 $gap/2;
      width: vw(120);

      &:last-child {
        box-sizing: content-box;
        padding-right: $gap;
      }
    }

    .list-line-inner {
      li {
        padding: vw(8) 0 vw(8) vw(0);
        font-size: vw(10);

        & > .list-note {
          font-size: 1em;
        }
      }
    }

    .arrow-button {
      $size: vw(24);
      width: $size;
      top: vw(100);
      &.-left {
        left: vw(42);
      }
      &.-right {
        right: 0;
      }
    }

    .isFixed {
      .arrow-button {
        &.-left {
          left: vw(202);
        }
      }
    }

    .arrow-icon {
      width: vw(12);
      height: vw(4);
      top: vw(1);
    }

    .sort-panel {
      width: auto;
      top: vw(40);
    }
  }
}
</style>
